var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11.5 13.837c2.104 0 3.81-1.71 3.81-3.82s-1.706-3.819-3.81-3.819a3.815 3.815 0 0 0-3.81 3.82c0 2.11 1.706 3.82 3.81 3.82Zm0 0c-2.218 0-4.158.89-5.225 2.222m5.225-2.222c2.217 0 4.158.89 5.225 2.222M7.226 1.833h8.547c.312 0 .565.255.565.57 0 1.573 1.263 2.849 2.822 2.849h.403c.356 0 .645.291.645.651v.839c0 5.41-2.906 10.395-7.59 13.023l-.367.205a1.53 1.53 0 0 1-1.502 0l-.366-.205c-4.686-2.628-7.591-7.613-7.591-13.023v-.839c0-.36.288-.651.645-.651h.403c1.558 0 2.822-1.276 2.822-2.849 0-.315.253-.57.564-.57Z"
  })));
};
export default SvgSecurity;